// extracted by mini-css-extract-plugin
export var actions = "_sq-4";
export var item = "_sq-1";
export var price = "_sq-3";
export var quantity = "_sq-2";
export var table = "_sq-0";